module.exports = __webpack_public_path__ + "img/document_level_analysis.99ba101f.webp";